module.exports = __webpack_public_path__ + "static/media/prequal-logo-2017-v.2.1.08da98cc.svg";